import React from "react";
import ApplicationDashboardPage from "../../recruitment-shared/pages/ApplicationDashboardPage";

export default function NonFacultyApplicationDashboard() {
  return <ApplicationDashboardPage type="NON_FACULTY" />;
}
